import React, { useState } from 'react';
import './Registro.css';
import { enviarCorreo } from './api'; // Importar la función desde api.js
import { useNavigate } from 'react-router-dom';

const Registro = () => {
  const Navigate = useNavigate();

  const [formData, setFormData] = useState({
    name_emp: '',
    nit_emp: '',
    address_emp: '',
    phone_emp: '',
    email_emp: '',
    website_emp: '',
    expire_date_emp: '',
    picture_emp: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Crear cuerpoHTML con la información del formulario y agregar el botón de verificación
    const cuerpoHTML = `
    <div style="font-family: 'Roboto', Arial, sans-serif; color: #202124; line-height: 1.6; margin: 0; padding: 0;">
      <div style="text-align: center; border-bottom: 1px solid #dadce0; padding-bottom: 10px; margin-bottom: 20px;">
        <h1 style="color:rgb(0, 0, 0); font-size: 24px; margin: 0;">Información de verificación</h1>
        <h2 style="color:rgb(49, 49, 49); font-size: 20px; margin: 0;">para creación de una empresa nueva en nuestro software LogistiKa</h2>
      </div>
      <div style="padding: 20px; border: 1px solid #dadce0; border-radius: 8px; background-color: #f8f9fa;">
        <p><strong>Nombre:</strong> ${formData.name_emp}</p>
        <p><strong>NIT:</strong> ${formData.nit_emp}</p>
        <p><strong>Dirección:</strong> ${formData.address_emp}</p>
        <p><strong>Teléfono:</strong> ${formData.phone_emp}</p>
        <p><strong>Correo Electrónico:</strong> ${formData.email_emp}</p>
        <p><strong>Sitio Web:</strong> ${formData.website_emp}</p>
      </div>
      <div style="text-align: center; margin-top: 20px;">
        <p>La información es correcta?</p>
        <a href="https://www.logistika.cindetemm.org.co/api/verificar.php?name_emp=${encodeURIComponent(formData.name_emp)}&nit_emp=${encodeURIComponent(formData.nit_emp)}&address_emp=${encodeURIComponent(formData.address_emp)}&phone_emp=${encodeURIComponent(formData.phone_emp)}&email_emp=${encodeURIComponent(formData.email_emp)}&website_emp=${encodeURIComponent(formData.website_emp)}" style="background-color:rgb(54, 130, 230); color: white; text-decoration: none; border: none; padding: 10px 20px; border-radius: 4px; font-size: 14px; cursor: pointer;">Es correcta</a>
        <p style="margin-top: 10px;">Si la información no es correcta, no haga nada para rechazar.</p>
      </div>
    </div>
    `;
  
  

    try {
      const response = await enviarCorreo(
        formData.email_emp,
        formData.name_emp,
        'Informacion de Registro de Empresa',
        cuerpoHTML
      );
      console.log(response); // Verificar la respuesta
      alert('¡Correo enviado con éxito! Revisa tu bandeja de entrada para verificar la información. Ten en cuenta que el correo puede tardar unos minutos en llegar. Si no lo encuentras, revisa también tu bandeja de spam o correo no deseado.');
    } catch (error) {
      console.error(error);
      alert('Ocurrió un error al enviar el correo');
    }
    Navigate('/'); // Redirigir a la página de inicio después de enviar el correo
  };

  return (
    <div className='empresaN'>
      <h2>Insertar Nueva Empresa</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nombre de la Empresa:
          <input type='text' name='name_emp' value={formData.name_emp} onChange={handleChange} required />
        </label>
        <label>
          NIT:
          <input type='text' name='nit_emp' value={formData.nit_emp} onChange={handleChange} required />
        </label>
        <label>
          Dirección:
          <input type='text' name='address_emp' value={formData.address_emp} onChange={handleChange} required />
        </label>
        <label>
          Teléfono:
          <input type='text' name='phone_emp' value={formData.phone_emp} onChange={handleChange} required />
        </label>
        <label>
          Correo Electrónico:
          <input type='email' name='email_emp' value={formData.email_emp} onChange={handleChange} required />
        </label>
        <label>
          Sitio Web:
          <input type='url' name='website_emp' value={formData.website_emp} onChange={handleChange} />
        </label>
        <button type='submit'>Enviar Correo de verificación</button>
        <button type='button' onClick={() => Navigate('/')}>Cancelar</button>
      </form>
    </div>
  );
};

export default Registro;
